import { AppointmentServiceModel } from '@models/appointment-service.model';
import { WorkerMinutesBlockDao } from '@models/availability.model';

// Do the selected services draw resources (room booking)? The flag is set by
// `appointment_services_by_store`; a service loaded without it counts as "no".
// The amounts are the second half of the backend's own gate: the availability engine only
// builds owner+resource combinations when the summed booking-type amounts are > 0
// (`WorkersPeriodAvailability::calculateRequiredWorkersCount`). A service whose booking types
// all carry amount 0 keeps whole-pool blocks, so it must stay on the owner-only branch.
// EVERY selected service must qualify: for a multi-service request the engine loads the
// booking-type configs of its first service only, so a mixed basket (a plain service next to
// a room service) can come back as whole-pool blocks — those must not be handed over.
export function servicesRequestResources(services: AppointmentServiceModel[] | undefined): boolean {
  const selected = services ?? [];
  return selected.length > 0
    && selected.every(service => !!service?.is_resources_requested && requestedResourceAmount(service) > 0);
}

function requestedResourceAmount(service: AppointmentServiceModel): number {
  return (service.booking_types ?? []).reduce((total, bookingType) => total + Number(bookingType?._joinData?.amount ?? 0), 0);
}

// A slot block carries the ONE human owner in `worker`. `workers[]` is the booked
// combination (owner + drawn room) only when the service draws resources; for a plain
// service it is the whole candidate pool of the block, and handing that over books every
// candidate (the defect hotfix/7.2.2 fixed). The backend books exactly the UUIDs it
// receives — nothing re-draws a required room at booking time — so a resource that is not
// handed over is simply never booked. Same rule the classic widget applies since hotfix/7.8.8.
export function resolveSlotWorkerUuids(
  block: WorkerMinutesBlockDao,
  isAnyoneSelected: boolean,
  isResourcesRequested: boolean
): string[] {
  if (isAnyoneSelected && !isResourcesRequested) {
    return [block.worker.uuid];
  }
  return block.workers.map(worker => worker.uuid);
}
